import Vue, { DirectiveOptions } from 'vue';
import { ThisTypedComponentOptionsWithArrayProps } from 'vue/types/options';
import Popup from '../components/Popup.vue';
import { EventBus } from '../helpers/bus';

const addParameterToURL = (url: string, param: string): string => {
    return url + (url.split('?')[1] ? '&' : '?') + param;
};

export interface ModalData {
    argsToPass: { [key: string]: any };
    inlineContent: any;
    isLoaded: boolean;
}

export const showPopup = (componentOptions: ThisTypedComponentOptionsWithArrayProps<Vue, ModalData, {}, {}, 'href', {}, any, any>, props?: any, settings?: any): void => {
    Vue.prototype.$modal.show(componentOptions, props, settings);
};

const onClick = (anchor: HTMLElement | HTMLAnchorElement, argsToPass?: any, inlineContent?: string | null) => (event: Event): void => {
    event.preventDefault();
    if (anchor instanceof HTMLAnchorElement || inlineContent !== null) {
        const vm: ThisTypedComponentOptionsWithArrayProps<Vue, ModalData, {}, {}, 'href', {}, any, any> = {
            template: `
                <div class="v-modal">
                    <div class="v-modal__close" slot="top-right" v-show="isLoaded">
                        <button class="v-modal__close-button" @click="$emit('close')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="v-modal__content">
                        <div v-if="inlineContent !== null" class="v-popup-content" v-html="inlineContent"></div>
                        <popup v-else :link="href" @loaded="isLoaded = true" :props="argsToPass" @error="$emit('close')"></popup>
                    </div>
                </div>`,
            props: ['href'],
            components: {
                popup: Popup,
            },
            data() {
                return {
                    argsToPass,
                    inlineContent,
                    isLoaded: inlineContent !== null,
                };
            },
            mounted() {
                EventBus.$on('shouldScrollTo', ({ top }: { top: number, left?: number }) => {
                    (this.$parent as any).$el.scrollTop = top;
                });
            },
        };

        // In call v-popup directive we can add a 'template' attribute.
        // If we use headless mode we can set a template for using. Endpoint will call with this parameter.
        let href = addParameterToURL((anchor instanceof HTMLAnchorElement ? anchor.href : ''), 'headless=1');
        if (argsToPass !== null // because typeof null === 'object'
            && typeof argsToPass === 'object'
            && Object.prototype.hasOwnProperty.call(argsToPass, 'template')
            && typeof argsToPass.template === 'string'
        ) {
            href = addParameterToURL(href, `template=${argsToPass.template}`);
        }

        showPopup(vm, { href }, {
            width: 960,
            height: 'auto',
            // clickToClose: false,
            adaptive: true,
            scrollable: true,
            pivotY: 0.15,
        });
    }
};

let callback: any = null;

const popup: DirectiveOptions = {
    bind(el: HTMLElement | HTMLAnchorElement, { value }): void {
        const src = el.getAttribute('data-src');
        if (src !== null) {
            const target = document.querySelector(src);
            if (target !== null) {
                callback = onClick(el, value, target.innerHTML);
                el.addEventListener('click', callback);
            }
        } else {
            callback = onClick(el, value, null);
            el.addEventListener('click', callback);
        }
    },
    unbind(el: HTMLElement | HTMLAnchorElement): void {
        el.removeEventListener('click', callback);
    },
};

export default popup;
